///
/// EarthBrowser
///
/// Created by Matt Giger on 8/19/2024
/// Copyright (c) 2024 Geodata Labs
///

import { animation } from "@stovokor/math/animation"

/**
 * A class that waits for a condition to be met before calling a callback.
 * @extends animation
 *
 * @example
 * // Wait for up to 1.5 seconds polling the condition, quitting early if the condition is met
 * const waiter = new waiter()
 * 		.wait(1.5, pollingFunction)
 * 		.finally(() => console.log('done'))
 */
export class waiter extends animation {
	private testFunction: () => boolean = () => false
	private callback: () => void = () => {}

	public wait(duration: number, testFunction: () => boolean): waiter {
		this.testFunction = testFunction
		this.duration(duration)
		return this
	}

	public finally(callback: () => void): waiter {
		this.callback = callback
		if(this.testFunction()) {
			callback()
		} else {
			this.
				onUpdate((_v) => {
					if(this.testFunction()) {
						this.callback()
						this.stop()
					}
				})
				.onComplete(() => {
					this.callback()
				})
				.start()
		}
		return this
	}
}